import React from "react";

import { useDispatch } from "react-redux";

import { openModal } from "../../store/slices/modal";

import { useGetExpertConversations } from "../../hooks/users";

import MainLayout from "../layouts/Main";
import Chats from "../sub_components/student/notifications/Chats";
import ChatPreviewCard from "../sub_components/ChatPreviewCard";
import { SVGIcon } from "../wrappers/SVGIcon";

import { Icons } from "../../data/Assets";

const ChatsPage = () => {
    const dispatch = useDispatch();
    const { data: expertConversations } = useGetExpertConversations();

    const onNewChat = () => {
        dispatch(openModal({
            name: 'NEW_CHAT_MODAL',
            data: {
                view: 'NEW_CHAT',
            }
        }));
    };

    return (
        <MainLayout>
            <div className="immersion__page_view">
                <h2 className="immersion__color__dark mb_20">Chats</h2>

                <div className="immersion__lists__top_section mb_30">
                    <div className="display_flex display_flex_end mr_10">
                        <button
                            className="mr_10 immersion__btn immersion__btn__primary"
                            onClick={onNewChat}
                        >
                            <SVGIcon src={Icons.Plus} />
                            <span>New&nbsp;Chat</span>
                        </button>

                        <button className="immersion__btn immersion__btn__outline__primary immersion__btn__outline__primary__disabled">
                            <SVGIcon src={Icons.Download4} />
                            <span>Import&nbsp;Excel</span>
                        </button>
                    </div>

                </div>
                <Chats>
                    {expertConversations?.map((expertConversation) => (
                        <ChatPreviewCard
                            key={expertConversation.id}
                            expertConversation={expertConversation}
                        />
                    ))}
                </Chats>
            </div>
        </MainLayout>
    );
};

export default ChatsPage;